import * as React from "react";
import { useNavigate } from "react-router";
import { ulid } from "ulid";

export const OpenChatView: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const conversationId = ulid();
    navigate(`/open-chat/${conversationId}`);
  }, [navigate]);

  return null;
};
